var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"h-header"},[_c('div',{staticClass:"logo-image"},[_c('img',{attrs:{"src":_vm.getLogo(_vm.logoName),"alt":"logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }